<template>
  <div class="addAndModify">
    <el-container>
      <el-main ref="main" class="tabWrap">
        <el-tabs  v-model="activeName" style="width: 100%">
          <el-tab-pane label="基本信息" name="Tab1" style="height: 700px;overflow-y: auto">
            <el-form class="dataFormBox" :rules="rules" :inline="true" :model="dataForm">
              <el-row>
                <el-col :span="12">
                  <el-form-item label-width="120px" label="标题：" prop="title">
                    <el-input v-model="dataForm.title" placeholder="请输入标题" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label-width="120px" label="发文字号：" prop="documentNum">
                    <el-input v-model="dataForm.documentNum" placeholder="请输入发文字号" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label-width="120px" label="发文日期：">
                    <el-date-picker
                        v-model="dataForm.documentDate"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <div class="sendList">
                    <el-form-item
                        label="发文部门："
                        label-width="120px"
                        ref="sendListRef"
                        prop="deptInfo"
                    >
                      <div class="el-input tag-wrapper">
                        <el-tag
                            v-for="(tag, index) in dataForm.deptInfo"
                            @close="closeAttend(tag)"
                            :key="index"
                            closable
                            style="margin-right: 5px;"
                        >{{ tag.name }}</el-tag
                        >
                      </div>
                      <el-button @click="selectParticipanceList()" type="primary"
                      >选择</el-button
                      >
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label-width="120px" label="附件：" prop="fileList">
                    <upload-file
                        :tableList="fileList"
                        @submit="doSubmitFiles">
                    </upload-file>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="权限信息" name="Tab2" style="height: 700px;overflow-y: auto">
            <el-form class="dataFormBox" :inline="true" :model="dataForm">
              <el-row>
                <el-col :span="12">
                  <el-form-item label-width="120px" label="阅读权限：">
                    <el-select v-model="dataForm.permissionList[0].type" placeholder="请选择" @change="(val)=>setPermissionList(val,0)">
                      <el-option
                          v-for="item in uploadOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label-width="120px" label="下载权限：">
                    <el-select v-model="dataForm.permissionList[1].type" placeholder="请选择" @change="(val)=>setPermissionList(val,1)">
                      <el-option
                          v-for="item in uploadOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div v-if="dataForm.permissionList[0].type == '0'" style="height: 10px"></div>
                  <div v-if="dataForm.permissionList[0].type == 1" class="formItem">
                    <el-form-item label-width="120px" label="部门：">
                      <el-tree ref="deptTree1"
                          :data="allDeptList"
                          :props="defaultTreeProps"
                           node-key="id"
                           show-checkbox
                      ></el-tree>
                    </el-form-item>
                  </div>
                  <div v-if="dataForm.permissionList[0].type == 2">
                    <el-form-item label-width="120px" label="岗位：">
                      <el-table
                          ref="dataTable1"
                          :data="jobList"
                          highlight-current-row
                          @selection-change="handleSelectionChange1"
                          size="mini"
                          height="100%"
                          border
                      >
                        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                        <el-table-column
                            prop="name"
                            label="岗位"
                            :show-overflow-tooltip="true"
                        ></el-table-column>
                      </el-table>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div v-if="dataForm.permissionList[1].type == 1" class="formItem">
                    <el-form-item label-width="120px" label="部门：">
                      <el-tree ref="deptTree2"
                               :data="allDeptList"
                               :props="defaultTreeProps"
                               node-key="id"
                               show-checkbox
                      ></el-tree>
                    </el-form-item>
                  </div>
                  <div v-if="dataForm.permissionList[1].type == 2">
                    <el-form-item label-width="120px" label="岗位：">
                      <el-table
                          ref="dataTable2"
                          :data="jobList"
                          highlight-current-row
                          @selection-change="handleSelectionChange2"
                          size="mini"
                          height="100%"
                      >
                        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                        <el-table-column
                            prop="name"
                            label="岗位"
                            :show-overflow-tooltip="true"
                        ></el-table-column>
                      </el-table>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-main>
      <el-footer class="container">
        <div class="btnMid">
          <el-button type="info" @click="close()">关闭</el-button>
          <el-button v-if="documentType == 1" type="info" @click="submitForm()">保存</el-button>
          <el-button v-if="documentType == 2" type="info" @click="submitForm()">修改</el-button>
        </div>
      </el-footer>
    </el-container>
    <select-dialog
        :visible="selectDialogVisible"
        @close="selectDialogClose"
        title="选择"
        v-bind="selectDialogOptions"
    />
  </div>
</template>

<script>
  import config from "@/common/config";
  import UploadFile from "@/page/document/manage/uploadFile";
  import SelectDialog from "@/page/meeting/bill/SelectDialog";
  import {
    getDeptListService,
    getsubDeptService,
    manangerStationService, //获取岗位列表
  } from "@/services/sysSettingService";
  import {
    addRuleService,
    modifyRuleService,
    getRuleDetailService,
    getPermissionService,
    getAllDeptListService,
  } from "@/services/institutionService";

  export default {
    name: "addAndModify",
    data(){
      return {
        activeName: 'Tab1',
        documentType: 1,
        dataForm: {
          title: '',  //标题
          documentNum: '',  //发文字号
          documentDate: '',  //发文日期
          deptInfo: [],  //发文部门
          permissionList: [
            {
              operateType: 1,
              permissionResourceIdList: [0],
              type: 0
            },
            {
              operateType: 2,
              permissionResourceIdList: [0],
              type: 0
            }
          ],
        },

        rules: {
          title: [
            { required: true, message: '请输入标题', trigger: 'blur' },
          ],
          documentNum: [
            { required: true, message: '请输入发文字号', trigger: 'blur' },
          ],
          deptInfo: [
            { required: true, message: '请选择发文部门', trigger: 'change' },
          ],
          fileList: [
            { required: true, message: '请选择附件', trigger: 'change' },
          ],
        },
        uploadOptions: [
          {
            value: 0,
            label: '所有人'
          },
          {
            value: 1,
            label: '按部门'
          },
          {
            value: 2,
            label: '按岗位'
          }
        ],
        allDeptList:[],  //所有部门列表
        defaultTreeProps: {
          id: "id",
          label: "name",
          children: "subDeptList"
        },
        fileList:[],  //文件列表
        jobList:[],  //岗位列表

        selectDialogVisible: false,
        selectDialogOptions: {
          departOn: true,
          groupOn: true,
          canSelectDepart: false,
          canSelectUser: true,
          canSelectGroup: false,
          maxSelectedItem: 1,
          dataKey: "sendListJson",
          canSelectAll: true
        },
      }
    },
    components: {
      SelectDialog,
      UploadFile,
    },
    methods:{
      onActive(menuCode) {
        this.getJobList();
        this.getAllDeptList();
        this.documentType = this.tabRouteParam.documentType

        if(this.tabRouteParam.id){
          this.dataForm.id = this.tabRouteParam.id;
          this.getRuleDetail();
        }
      },
      //获取详情
      getRuleDetail(){
        let paramsData = {
          systemRuleId: this.dataForm.id
        }
        getRuleDetailService(paramsData).then( res => {
          if(res.code == 10000000){
            this.dataForm =  {
              ...this.dataForm,
              title: res.data.title,  //标题
              documentNum: res.data.documentNum,  //发文字号
              documentDate: res.data.documentDate,  //发文日期
              deptInfo: [{
                name:  res.data.deptName,
                deptId: res.data.deptId,
              }],  //发文部门
              // permissionList: res.data.permissionList,
              publishUserName: res.data.publishUserName,
              publishTime: res.data.publishTime,
            }
            this.fileList = res.data.attachmentList;
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error => {
          this.$message.error("网络请求失败");
        });
      },
      //获取权限
      getPermission(){
        let paramsData = {
          systemRuleId: this.dataForm.id
        }
        getPermissionService(paramsData).then( res => {
          if(res.code == 10000000){
            if(res.data.permissionList.length != 2){
              return
            }
            this.dataForm.permissionList =  res.data.permissionList.sort(this.compare('operateType'));
            this.$nextTick(()=> {
              this.dataForm.permissionList.map((item, index) => {
                if(item.type == 1 ){
                  let deptTree = 'deptTree'+ (index + 1);
                  this.$refs[deptTree].setCheckedKeys(item.permissionResourceIdList);
                }else if(item.type == 2){
                  let deptTree = 'dataTable'+ (index + 1);
                  let arr = [];
                  this.jobList.map(jobItem =>{
                    if(item.permissionResourceIdList.findIndex(perItem => perItem == jobItem.id) != -1){
                      arr.push(jobItem)
                    }
                  })
                  arr.forEach(row => {
                    this.$refs[deptTree].toggleRowSelection(row);
                  });
                }
              })
            })
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error => {
          this.$message.error("网络请求失败");
        });
      },
      compare(property){
        return function(a,b){
          let value1 = a[property];
          let value2 = b[property];
          return value1 - value2;
        }
      },
      //获取全部部门列表
      getAllDeptList(){
        getAllDeptListService().then((res) => {
          if (res.code == 10000000) {
            this.allDeptList = res.data;
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        },(err) => {
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        });
      },
      //获取岗位下拉列表
      getJobList() {
        let reqParam = {
          orgId: sessionStorage.getItem('orgId'),
          pageIndex: 1,
          pageSize: 10000,
        };
        manangerStationService(reqParam).then(
            (res) => {
              console.log(res);
              if (res.code == 10000000) {
                this.jobList = res.data;
                if(this.tabRouteParam.id){
                  this.getPermission();
                }
              } else if (res.code >= 20000000) {
                this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                this.$alert("系统异常", "提示", {
                  confirmButtonText: "确定",
                });
              }
            },
            (err) => {
              console.log("123");
              this.$alert(err, "提示", {
                confirmButtonText: "确定",
              });
            }
        );
      },

      setPermissionList(val,type){
        if(val == '0'){
          this.dataForm.permissionList[type].permissionResourceIdList = [0];
        }else if(val == '1') {
          let deptTree = 'deptTree'+ (type + 1);
          this.$nextTick(()=>{
            for (var i in this.$refs[deptTree].store.nodesMap) {
              this.$refs[deptTree].store.nodesMap[i].expanded = true;
            }
          })
        }

      },
      // 列代表多选回调
      handleSelectionChange1(val) {
        this.dataForm.permissionList[0].permissionResourceIdList = val.map(item => item.id)
      },
      // 列代表多选回调
      handleSelectionChange2(val) {
        this.dataForm.permissionList[1].permissionResourceIdList = val.map(item => item.id)
      },
      //选择部门
      selectParticipanceList(){
        this.selectDialogOptions = {
          departOn: true,
          groupOn: false,
          canSelectDepart: true,
          canSelectUser: false,
          canSelectGroup: false,
          maxSelectedItem: 0,
          dataKey: 'attendDepart'
        };
        this.selectDialogVisible = true;
      },
      // 选择部门和人员
      selectDialogClose(data) {
        this.selectDialogVisible = false;
        let departList = data.departList || [];
        departList.forEach(o => {
          let index = this.dataForm.deptInfo.findIndex(
              p => p.id == o.id
          );
          if (index == -1) {
            this.dataForm.deptInfo.push({
              deptId: o.id,
              name: o.name
            });
          }
        });
        if(this.dataForm.deptInfo.length > 1){
          this.$message.error('拟稿部门只能选择一个！');
          this.dataForm.deptInfo = [];
        }
      },
      // 删除列席部门
      closeAttend(tag) {
        let index = this.dataForm.deptInfo.indexOf(tag);
        if (index != -1) {
          this.dataForm.deptInfo.splice(index, 1);
        }
      },
      // 修改附件列表后的回调
      doSubmitFiles(files) {
        this.fileList = files;
      },
      submitForm(){
        if(!this.dataForm.title){
          this.$message.error('请输入标题！');
          return
        }
        if(!this.dataForm.documentNum){
          this.$message.error('请输入发文字号！');
          return
        }
        if(this.dataForm.deptInfo.length == 0){
          this.$message.error('请选择发文部门！');
          return
        }
        if(this.fileList.length == 0){
          this.$message.error('请选择上传附件！');
          return
        }
        let isError = false;
        this.dataForm.permissionList.map((item, index) => {
          if(item.permissionResourceIdList.length == 0) {
            isError = true;
          }
        })
        if(isError){
          this.$message.error('请选择具体权限！');
          return
        }
        if(this.documentType == 1){
          this.preserve();
        }else{
          this.modify();
        }
      },
      // 保存
      preserve(){
        this.dataForm.permissionList.map((item,index) => {
          if(item.type == 1){
            let deptTree = 'deptTree'+ (index + 1);
            item.permissionResourceIdList = this.$refs[deptTree].getCheckedKeys();
            if(item.permissionResourceIdList.length == 0) {
              item.permissionResourceIdList = [0]
            }
          }else {
            if(item.permissionResourceIdList.length == 0) {
              item.permissionResourceIdList = [0]
            }
          }
        })
        let params = {
          ...this.dataForm,
          deptId: this.dataForm.deptInfo.length > 0?this.dataForm.deptInfo[0].deptId: '',
          attachmentList: this.fileList,
        }
        addRuleService(params).then( res => {
          if(res.code == 10000000){
            this.$message.success('新增成功！');
            this.close();
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error => {
          this.$message.error("网络请求失败");
        });
      },
      // 修改
      modify(){
        this.dataForm.permissionList.map((item,index) => {
          if(item.type == 1){
            let deptTree = 'deptTree'+ (index + 1);
            item.permissionResourceIdList = this.$refs[deptTree].getCheckedKeys();
            if(item.permissionResourceIdList.length == 0) {
              item.permissionResourceIdList = [0]
            }
          }else {
            if(item.permissionResourceIdList.length == 0) {
              item.permissionResourceIdList = [0]
            }
          }
        })

        let params = {
          ...this.dataForm,
          deptId: this.dataForm.deptInfo.length > 0?this.dataForm.deptInfo[0].deptId: '',
          attachmentList: this.fileList,
        }
        modifyRuleService(params).then( res => {
          if(res.code == 10000000){
            this.$message.success('修改成功！');
            this.close();
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error => {
          this.$message.error("网络请求失败");
        });
      },
      // 关闭
      close(){
        if(this.documentType == 1 ){
          this.bus.$emit("tabClose", "manageAdd");
          this.bus.$emit("navMenuChange", {
            routeId: "manageIndex"
          });
        }else {
          this.bus.$emit("tabClose", "manageModify");
          this.bus.$emit("navMenuChange", {
            routeId: "manageIndex"
          });
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  @import "@/assets/css/commonLayout.scss";
  .addAndModify {
    height: 100%;
    background-color: white;
    display: flex;
    flex-direction: column;
    .container{
      width: 900px;
    }
  }
  .tabWrap {
    height: calc(100% - 60px);

    /deep/ .el-tabs--top {
      height: 100%;
      overflow: hidden;

      .el-tabs__content {
        height: calc(100% - 80px);
        padding: 0 20px 20px;
        overflow: auto;

        .el-form-item {
          width: 100%;
        }

        .el-checkbox {
          line-height: 40px;
        }

        .el-textarea {
          min-width: 0px !important;
        }
        .el-cascader {
          width: 100%;
        }

        .el-form-item__content {
          width: calc(100% - 150px);

          .el-input {
            width: 100%;
          }
        }
      }
    }
  }
  /deep/.el-container .el-main{
    height: 100%;
  }
  /deep/.el-textarea{
    width: 600px;
  }
  /deep/.el-tabs__header{
    padding-right: 0 !important;
    .el-tabs__nav-wrap{
      padding-left: 30px;
    }
  }
  /deep/.el-input.is-disabled .el-input__inner{
    background-color: #fff !important;
    color: #606266 !important;
  }
  .sendList {
    /deep/.el-form-item{
      width: 100%;
      display: flex;
      .el-form-item__content {
        width: 70%;
        display: flex;
        .el-input {
          flex: 1;
        }
        .el-button {
          margin-left: 10px;
          height: fit-content;
        }
      }
    }

    .tag-wrapper {
      border: 1px solid #dcdfe6;
      padding: 0 5px;
    }
  }
  .formItem{
    /deep/.el-form-item{
      display: flex;
      align-items: flex-start;
      .el-tree-node__content{
        padding-top: 6px;
      }
    }
  }
  .btnMid {
    width: 300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
  }
</style>
